<template>

    <div class="icon-scroller" @scroll="hideTooltip">
        <div class="icon-scroller-track">
            <div v-for="(icon, index) in icons" :key="`is-${index}`" class="icon" :class="{ selected: icon === key }" v-tooltip="iconTooltip(icon)" @click="selectIcon(icon)">
                <i :class="icon" />
            </div>
        </div>
    </div>

</template>

<style lang="scss" scoped>

    .icon-scroller {
        overflow-x: auto;
        overflow-y: hidden;
        .icon-scroller-track {
            display: flex;
            flex-wrap: nowrap;
            gap: 5px;
            padding-bottom: 5px;
        }
    }

    .icon {
        align-items: center;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        color: $color-text;
        cursor: pointer;
        display: flex;
        flex-shrink: 0;
        font-size: 16px;
        justify-content: center;
        height: 50px;
        transition: all .3s;
        width: 50px;
        &:hover {
            border-color: $color-text;
        }
        &.selected {
            background-color: $color-text;
            border-color: $color-text;
            color: $color-white;
        }
    }

</style>

<script>

export default {

    props: {
        icons: {
            type: Array,
            default: () => [],
        },
        model: {
            required: true,
        },
    },

    data() {
        return {
            key: null,
            defaultIcons: [
                'fas fa-tag',
                // Sentiment
                'fas fa-star',
                'fas fa-thumbs-up',
                'fas fa-thumbs-down',
                'fas fa-heart',
                'fas fa-face-smile',
                'fas fa-face-frown',
                'fas fa-face-meh',
                // Feedback
                'fas fa-comment',
                'fas fa-comments',
                'fas fa-message',
                'fas fa-bullhorn',
                'fas fa-lightbulb',
                // Service & staff
                'fas fa-headset',
                'fas fa-hands-holding-heart',
                'fas fa-handshake',
                'fas fa-bell-concierge',
                'fas fa-users',
                'fas fa-user-tie',
                // Quality
                'fas fa-trophy',
                'fas fa-medal',
                'fas fa-award',
                'fas fa-sparkles',
                'fas fa-gem',
                'fas fa-circle-check',
                'fas fa-triangle-exclamation',
                // Speed & delivery
                'fas fa-clock',
                'fas fa-bolt',
                'fas fa-truck-fast',
                // Value & trust
                'fas fa-dollar-sign',
                'fas fa-shield-check',
                'fas fa-gift',
                // Place & amenities
                'fas fa-store',
                'fas fa-location-dot',
                'fas fa-house-chimney-heart',
                'fas fa-calendar-check',
                'fas fa-wifi',
                'fas fa-broom',
                'fas fa-phone',
                // Product & industry
                'fas fa-utensils',
                'fas fa-pot-food',
                'fas fa-burger',
                'fas fa-coffee',
                'fas fa-car',
                'fas fa-wrench',
                'fas fa-toolbox',
                'fas fa-palette',
                'fas fa-flower-tulip',
                'fas fa-mobile',
                'fas fa-desktop',
            ],
        };
    },

    created() {
        if (this.icons.length === 0) {
            this.icons = this.defaultIcons;
        }
        const resolved = this.resolveSelection(this.model);
        this.key = resolved;
        if (!this.model || this.model !== resolved) {
            this.$emit('input', resolved);
        }
    },

    mounted() {
        this.$nextTick(() => this.scrollSelectedIntoView());
    },

    watch: {
        model(val) {
            this.key = this.resolveSelection(val);
        },
    },

    methods: {

        iconLabel(icon) {
            return String(icon).replace(/^(fab|fad|fak|fal|far|fas|fat)\s+/, '').replace(/^fa-/, '');
        },

        iconTooltip(icon) {
            return {
                content: this.iconLabel(icon),
                delay: { show: 100, hide: 0 },
                placement: 'top',
                popperOptions: {
                    modifiers: {
                        flip: { enabled: false },
                        preventOverflow: { boundariesElement: 'viewport' },
                    },
                },
            };
        },

        resolveSelection(val) {
            if (val && this.icons.includes(val)) return val;
            return this.icons[0] ?? null;
        },

        hideTooltip() {
            this.$el.querySelectorAll('.icon').forEach((el) => {
                if (el._tooltip) {
                    el._tooltip.hide();
                }
            });
        },

        scrollSelectedIntoView() {
            const el = this.$el?.querySelector('.icon.selected');
            if (el) el.scrollIntoView({ block: 'nearest', inline: 'center' });
        },

        selectIcon(icon) {
            this.key = icon;
            this.$emit('input', icon);
        },
    },

}

</script>
